<script setup>
import { ref } from "vue";

// State to track if the menu is open
const isTooltipOpen = ref(false);

// Function to toggle state
const toggleTooltip = () => {
  isTooltipOpen.value = !isTooltipOpen.value;
};
</script>

<template>
  <div>
    <div class="relative banner-wrapper">
      <img
        class="banner-image rounded-2xl"
        :src="require('@/assets/img/community_banner.jpg')"
      />

      <h1 class="header-title">하나 바이블 사역 나눔터</h1>
      <h4 class="header-subtitle">
        하나 바이블로 물든 우리 교회 이야기, 함께 나누고, 함께 성장해요!
      </h4>
    </div>
  </div>

  <div>
    <div class="relative w-fit text-center mx-auto">
      <p class="my-5 px-3 font-light max-md:text-sm">
        [매달 우수 참여교회]를 선정하여 특별 혜택과 사역 소개 기회를
        드립니다!<br />
        <span class="font-normal">#사역꿀팁 #현장노하우 #나만의자료</span>를
        지금 바로 나누고, 하나님 나라를 위한 동역에 참여하세요!
      </p>

      <button
        class="underline underline-offset-2 flex items-center justify-center gap-2 mx-auto text-lg"
        @click="toggleTooltip"
      >
        어떤 자료를 공유하면 좋을까요?
        <font-awesome-icon
          icon="fa-solid fa-chevron-down"
          class="transition-transform duration-300"
          :class="{ 'rotate-180': isTooltipOpen }"
        />
      </button>

      <Transition name="fade-slide">
        <ul
          v-if="isTooltipOpen"
          class="absolute top-full left-1/2 -translate-x-1/2 z-10 text-left text-black bg-white p-4 rounded-xl shadow-xl w-full max-w-md space-y-1 mt-2"
        >
          <li class="flex items-center gap-2">
            <span class="text-blue-500">✓</span> 아이들이 좋아하는 공과 활용
            꿀팁
          </li>
          <li class="flex items-center gap-2">
            <span class="text-blue-500">✓</span> 하나 바이블 활용 특별 이벤트
          </li>
          <li class="flex items-center gap-2">
            <span class="text-blue-500">✓</span> 사역 현장 이모저모
          </li>
          <li class="flex items-center gap-2">
            <span class="text-blue-500">✓</span> 교사교육 및 부서 운영 팁 및
            자료
          </li>
        </ul>
      </Transition>
    </div>
  </div>
</template>

<style scoped>
.banner-wrapper {
  @apply relative w-full max-lg:w-[92%] h-[19.125rem] max-lg:min-h-fit max-lg:p-5 flex flex-col justify-center items-center max-w-[89rem] mx-auto;
}

.banner-image {
  @apply w-full h-full max-lg:object-cover absolute top-0 left-auto right-0 -z-10;
}

.header-title {
  @apply text-center font-bold text-white mx-auto text-xl md:text-4xl tracking-wider;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.6);
}

.header-subtitle {
  @apply text-center font-medium text-white mt-2 mx-auto max-md:text-base;
}

/* Vue Transition Styles */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.3s ease-out;
}

.fade-slide-enter-from,
.fade-slide-leave-to {
  opacity: 0;
  transform: translate(-50%, -20px);
}
</style>
